module.exports = __webpack_public_path__ + "img/AF_GusmãoLabrunie_Icones_brazilian-biodiversity.0f03cdd5.png";